// services/TenantPaymentSettingsService.ts

import { CreateTenantPaymentSettingsDto, UpdateTenantPaymentSettingsDto } from "../../types/tenantPaymentSettings.types";
import { get,post,patch } from "../../utils/BaseService";
  
  export async function getAllTenantPaymentSettings(dispatch: any) {
    return await get(dispatch, '/tenantPaymentSettings/getAll', null);
  }
  
  export async function getTenantPaymentSettingsById(dispatch: any, id: number) {
    return await get(dispatch, `/tenantPaymentSettings/getById/${id}`, null);
  }

  export async function getTenantPaymentSettingsByTenantId(dispatch: any, tenantId: string) {
    return await get(dispatch, `/tenantPaymentSettings/getByTenantId`, {tenantId:tenantId});
  }
  
  export async function getTenantPaymentSettingsByInvoiceId(dispatch: any, invoiceId: number) {
    return await get(dispatch, `/tenantPaymentSettings/getByInvoiceId/${invoiceId}`, null);
  }
  
  export async function createTenantPaymentSettings(dispatch: any, data: CreateTenantPaymentSettingsDto) {
    return await post(dispatch, "/tenantPaymentSettings/create", data);
  }
  
  export async function updateTenantPaymentSettings(dispatch: any, id: number, data: UpdateTenantPaymentSettingsDto) {
    return await patch(dispatch, "/tenantPaymentSettings/update", data, id);
  }